const Grid = {
    CELL_SIZE: 20,
    CELL_COUNT_X: 48,
    CELL_COUNT_Y: 40,
    EXPANSION_SIZE: 4,
};
export default Grid;
